<template>
  <div style="margin-top:3%;">
    <div v-if="dataFound" class="page-content">
      <div style="text-align:center">
        <h2 class="headline mb-4">Approved User Details</h2>
      </div>
      <div class="container">
        <div
          class="p-1 card"
          style="border-radius:10px;border-left:#2C80FF 4px solid;border-right:#2C80FF 4px solid"
        >
          <!-- <div style="padding:15px;border:1px black" class="input-group">
            <input
              type="search"
              id="serach"
              v-model="name"
              style="border-right:0"
              placeholder="Search by name / KYC ID / Location(Eg. City, Zip code , etc.)"
              aria-describedby="button-addon1"
              class="form-control bg-light"
            />
            <div class="input-group-append">
              <button
                type="submit"
                style="border-radius:0px 3px 3px 0px;border-left:0px "
                class="border bg-light px-2 py-0 text-primary btn-link"
              >
                <em class="fa fa-search"></em>
              </button>
            </div>
          </div> -->

          <div class="">
            <!-- <div class="card-head">
             
              <h4 v-if="getUserData.length > 0" class="card-title ml-2">KYC List</h4>
             
            </div> -->
            <div v-if="getUserData.length > 0">
             
                <vue-good-table
                 
                  :sort-options="{
                    enabled: false,
                  }"
                  :search-options="{
                    enabled: true,
                    externalQuery: search,
                    skipDiacritics: true,
                    searchFn: searchData,
                    placeholder:
                      'Search by name / KYC ID / Location(Eg. City, Zip code , etc.)',
                  }"
                  style="width:auto;z-index:0;border-radius:10px;"
                  :columns="columns"
                
                  :rows="getUserData"
                  :pagination-options="{
                    enabled: true,
                    mode: 'records',
                    perPage: 5,
                    position: 'bottom',
                    perPageDropdown: [5,3,7,10,15,20],
                    dropdownAllowAll: false,
                    setCurrentPage: 1,
                    nextLabel: 'next',
                    prevLabel: 'prev',
                    rowsPerPageLabel: 'Rows per page',

                    pageLabel: 'page', // for 'pages' mode
                    allLabel: 'All',
                  }"
                >
                  <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'user'">
                      <p class="font-bold mb-0">{{ props.row.name }}</p>
                      <p style="font-size:13px;" class=" mb-0 mt-0 pt-0">
                        {{ props.row.email }}
                      </p>

                      <!-- <span
                        class="dt-status-sm badge badge-sq badge-outline badge-success badge-md"
                        >A</span
                      > -->
                    </span>
                    <span v-if="props.column.field == 'status'">
                      <span class=" badge badge-outline badge-success badge-md"
                        >Approved</span
                      >
                      <!-- <span
                        class="dt-status-sm badge badge-sq badge-outline badge-success badge-md"
                        >A</span
                      > -->
                    </span>
                    <span v-if="props.column.field == 'viewDetails'">
                      <span
                        @click="
                          $router.push({
                            name: 'userData',
                            params: { userAddress: props.row.userAddress },
                          })
                        "
                      >
                        <span
                          style="margin-left:0"
                          href="#"
                          class="btn btn-light-alt btn-xs btn-icon"
                        >
                          <em class="ti ti-eye"></em> View Details
                        </span>
                      </span>
                    </span>
                    <span v-else>
                      {{ props.formattedRow[props.column.field] }}
                    </span>
                  </template>
                </vue-good-table>
           
            </div>
            <div
              v-else-if="
                getUserData.length <= 0 && $store.state.loading == false
              "
            >
              <center>
                <i
                  style="font-size:35px;color:grey"
                  class="far fa-frown mb-3"
                  aria-hidden="true"
                ></i>
                <h4 class="font-bold">No search results found</h4>
              </center>
            </div>
          </div>
          <!-- .card-innr -->
        </div>
        <!-- .card -->
      </div>

      <!-- .container -->
    </div>
    <div
      style="margin-top:5%;border:2px blue"
      v-else-if="dataFound == false"
      class="container"
    >
      <div class="row justify-content-center">
        <div
          style="border:0.9px solid blue;border-radius:10px;"
          class="card col-10 col-xs-12"
        >
          <div class="card-body">
            <center class="card-body">
              <i
                style="font-size:250px;color:grey"
                class="far fa-frown pa-5"
                aria-hidden="true"
              ></i>
              <h2 class="mt-5 font-bold">No data available to display</h2>
            </center>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "KYCDetailsGov",
  data() {
    return {
      userData: [],
      tempData: [],
      columns: [
        { label: "User", field: "user",width:'200px',tdClass:'text-center',thClass:'text-center' },
        { label: "Doc Type", field: "docType",tdClass:'text-center',thClass:'text-center' },
        { label: "Status", field: "status",tdClass:'text-center',thClass:'text-center' },
        { label: "View Details", field: "viewDetails",tdClass:'text-center',thClass:'text-center' },
      ],
      name: "",
      country: "",
      dataFound: undefined,
      len: 0,
      currentAddress: this.$cookies.get("address"),
      tronWeb: this.$store.state.tronWeb,
    };
  },
  asyncComputed: {
    async getUserData() {
      return this.userData.filter((data) => {
        return (
          data.name.toLowerCase().startsWith(this.name.toLowerCase()) ||
          data.email.toString().startsWith(this.name) ||
          data.address.toLowerCase().includes(this.name.toLowerCase())
        );
      });
    },
  },
  methods: {
    searchData(row, col, cellValue, searchTerm) {
      console.log(searchTerm);
      return (
        row.email.toLowerCase().startsWith(searchTerm.toLowerCase()) ||
        row.name.toLowerCase().startsWith(searchTerm.toLowerCase()) ||
        row.address.toLowerCase().includes(searchTerm.toLowerCase())
      );
    },
    async getGov() {
      let details = await this.$store.state.KYC.methods
        .getGovDetails(this.currentAddress)
        .call();
      console.log(details);
      this.country = details[1].toString();
    },
    // async getUpdatedDetails(address){
    //   try{

    //   let obj=undefined;
    //   let key = process.env.VUE_APP_API_KEY;
    //   let data=await axios({
    //       url: this.$store.state.eventUrl +"users"+ "?user=" + address,
    //       method: "get",

    //       headers: {
    //         Authorization: "Basic " + key,
    //       },
    //     });

    //     data=data.data.data.events;
    //   if(data.length>0)
    //   {
    //     let arr=data[data.length-1];
    //     //  obj={
    //     //   name:await decrypt(arr.returnValues.fullName),
    //     //     docType:await decrypt(arr.returnValues.docType),
    //     //     address:await decrypt(arr.returnValues.pAddress),
    //     //     email:arr.returnValues.email,

    //     //     userAddress:userAddress,

    //     //   }

    //     obj={
    //           name:await decrypt(arr.result.fullName),
    //         docType:await decrypt(arr.result.docType),
    //         address:await decrypt(arr.result.pAddress),
    //         email:arr.result.email,

    //         userAddress:address,
    //     }
    //   }

    //   return obj;
    //   }
    //   catch(err){

    //   }

    // },

    async getDetails(userAddress, fullName, email, docType, pAddress) {
      try {
        let blocked = await this.$store.state.KYC.methods
          .blocked(userAddress)
          .call();
        if (blocked == false) {
          let obj;
          // let obj=await this.getUpdatedDetails(userAddress);

          obj = {
            name: fullName,
            email: email,
            address: pAddress,
            docType:docType,

            userAddress: userAddress,
          };
          

          this.userData.push(obj);
          this.userData=this.userData.reverse();
        }
        this.userData = await [
          ...new Map(
            this.userData.map((item) => [item["userAddress"], item])
          ).values(),
        ];
      } catch (err) {
        console.log(err);
      }
    },
    async fetchDetails() {
      let key = process.env.VUE_APP_API_KEY;
      try {
        let govEvents = await axios({
          url:
            this.$store.state.eventUrl +
            "countries" +
            "?country=" +
            this.country,
          method: "get",

          headers: {
            Authorization: "Basic " + key,
          },
        });

        govEvents = govEvents.data.data.events;
        console.log(govEvents)

        if (govEvents.length == 0) {
          this.dataFound = false;
        }
        for (let i = 0; i < govEvents.length; i++) {
          this.$store.state.loading = true;
          this.dataFound = true;
          await this.getDetails(
            govEvents[i].result.user,
            govEvents[i].result.fullName,
            govEvents[i].result.email,
            govEvents[i].result.docType,
            govEvents[i].result.pAddress
          );
        }
        this.$store.state.loading = false;
      } catch (err) {
        console.log(err);
      }
    },
  },
  mounted() {
    const plugin1 = document.createElement("script");
    plugin1.setAttribute("src", "/js/jquery.bundle.js?ver=104");
    plugin1.async = true;
    document.head.appendChild(plugin1);
    const plugin2 = document.createElement("script");
    plugin2.setAttribute("src", "/js/script.js?ver=104");
    plugin2.async = true;
    document.head.appendChild(plugin2);
  },
  async created() {
    // this.$store.state.loading = true;
    this.$store.dispatch("setContract");
    await this.getGov();
    await this.fetchDetails();
  },
};
</script>
<style scoped>
@import "../assets/css/style.css";
@import "../assets/css/vendor.bundle.css?ver=104";
@import "../assets/css/style.css?ver=104";
</style>
